import React, { useEffect, useState } from "react";
import axios from "axios";
import config from "../../config";
import logo from "../../assets/images/Logo/logo-white.svg";
import { Link } from "react-router-dom";
import { Button, message, Form, Input, Space, Select, Spin } from "antd";
import {
  BankOutlined,
  LockOutlined,
  MailOutlined,
  PhoneOutlined,
} from "@ant-design/icons";

function normalizeEmail(s) {
  return (s || "").trim().toLowerCase();
}

function isValidEmail(s) {
  const t = normalizeEmail(s);
  if (!t) return false;
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(t);
}

function normalizeMobile(m) {
  const s = (m || "").trim();
  if (s.startsWith("0")) return "92" + s.slice(1);
  if (s.startsWith("+92")) return s.slice(1);
  return s;
}

function SignUp() {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [SignUpSuccess, setSignUpSuccess] = useState(false);
  const [SignUpData, setSignUpData] = useState({});
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [Optloading, setOptLoading] = useState(false);
  const [fuelProviders, setFuelProviders] = useState([]);
  const [loadingProviders, setLoadingProviders] = useState(false);

  const providerOptions = fuelProviders.map((item) => ({
    value: item.ID,
    label: item.Name,
    logo: `${config.images}${item.Logo_Reports || item.Logo_Login}`,
  }));

  const renderProviderLabel = (value) => {
    const item = fuelProviders.find((p) => p.ID === value);
    if (!item) return null;
    const logo = `${config.images}${item.Logo_Reports || item.Logo_Login}`;
    return (
      <div className="signup-provider-selected">
        <img src={logo} alt="" />
        <span>{item.Name}</span>
      </div>
    );
  };

  useEffect(() => {
    setSignUpSuccess(false);
    document.title = "Fuelbook - Create Your Account";

    setLoadingProviders(true);
    axios({
      method: "post",
      url: config.base_url + "Members/GetFuelProvidersForSignUp",
      headers: { "Content-Type": "application/json" },
      data: {},
    })
      .then(function (response) {
        if (response.data.status_code == 1) {
          setFuelProviders(response.data.ListofFuelProviders || []);
        } else {
          message.error(
            response.data.status_message || "Unable to load fuel providers."
          );
        }
      })
      .catch(function () {
        message.error("Unable to load fuel providers.");
      })
      .finally(function () {
        setLoadingProviders(false);
      });
  }, []);

  const handleSubmit = (formData) => {
    setLoading(true);

    const email = normalizeEmail(formData.Email);
    const mobile = normalizeMobile(formData.Mobile);

    const data = {
      ...formData,
      Email: email,
      Mobile: mobile,
      FuelProviderID: formData.FuelProviderID,
    };

    const api_config = {
      method: "post",
      url: config.base_url + "Members/SignUpWithOTP",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(api_config)
      .then(function (response) {
        if (response.data.status_code == 1) {
          setSignUpSuccess(true);
          setSignUpData(response.data);
        } else {
          setSignUpSuccess(false);
          message.error(
            response.data.status_message || "Registration could not be completed."
          );
        }
      })
      .catch(function (error) {
        setSignUpSuccess(false);
        const msg =
          error.response?.data?.status_message ||
          error.message ||
          "Network error. Please try again.";
        message.error(msg);
        console.log(error);
      })
      .finally(function () {
        setLoading(false);
      });
  };

  const handleEmailChange = (e) => {
    const email = (e.target.value || "").trim();
    setIsButtonDisabled(!isValidEmail(email));
  };

  const handleButtonClick = () => {
    const email = normalizeEmail(form.getFieldValue("Email"));
    if (!isValidEmail(email)) {
      message.error("Please enter a valid email address.");
      return;
    }
    form.setFieldsValue({ Email: email });

    setOptLoading(true);

    const data = {
      Email_Address: email,
    };

    const api_config = {
      method: "post",
      url: config.base_url + "OTP/SendSignUpOTP",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(api_config)
      .then(function (response) {
        if (response.data.status_code === 1) {
          message.success("OTP sent successfully!");
          setIsButtonDisabled(true);
          setTimeout(() => setIsButtonDisabled(false), 15000);
        } else {
          message.error(
            response.data.status_message ||
              "Could not send verification code."
          );
        }
      })
      .catch(function (error) {
        const msg =
          error.response?.data?.status_message ||
          "Error sending OTP: " + (error.message || "");
        message.error(msg);
      })
      .finally(function () {
        setOptLoading(false);
      });
  };

  return (
    <>
      <div className="auth-wrap">
        <div>
          <div className="auth-wrap">
            <div className="auth-head auth-head-compact">
              <div className="logo">
                <img src={logo} alt="" />
              </div>
              <p>Welcome</p>
              <h1>Create your account</h1>
            </div>
            <div className="auth-card auth-card-signup">
              {SignUpSuccess ? (
                <>
                  <h4 className="text-center">Welcome to Your New Account!</h4>
                  <p
                    style={{
                      fontSize: "16px",
                      color: "rgba(0,0,0,0.6)",
                      fontWeight: "normal",
                    }}
                  >
                    Thank you for signing up! Below are your account details.
                    Please take a moment to review and remember your pump code
                    and email for future access. <br />
                    <br />
                    Important: Keep your business code and email safe. You'll
                    need these to manage your account and access our services.
                  </p>

                  <ul className="signup-list">
                    <li>
                      <span className="lbl">Pump Code</span>
                      <span className="val">{SignUpData.PumpCode}</span>
                    </li>
                    <li>
                      <span className="lbl">Email</span>
                      <span className="val">{SignUpData.EmailAddress}</span>
                    </li>
                  </ul>

                  <Link to="/login">
                    <Button size="large" type="primary" block shape="round">
                      Login Now
                    </Button>
                  </Link>
                </>
              ) : (
                <>
                  <Form
                    form={form}
                    name="auth-form"
                    className="auth-form signup-form"
                    size="middle"
                    layout="vertical"
                    onFinish={handleSubmit}
                    requiredMark={false}
                  >
                    <Form.Item
                      name="Name"
                      label="Filling Station / Petrol Pump"
                      rules={[
                        {
                          required: true,
                          message: "Please enter your station name",
                        },
                      ]}
                    >
                      <Input
                        prefix={<BankOutlined />}
                        placeholder="Station name"
                      />
                    </Form.Item>

                    <Form.Item
                      name="FuelProviderID"
                      label="Fuel Provider Company"
                      rules={[
                        {
                          required: true,
                          message: "Please select your fuel provider",
                        },
                      ]}
                    >
                      <Select
                        showSearch
                        allowClear
                        placeholder="Search and select company"
                        loading={loadingProviders}
                        optionFilterProp="label"
                        options={providerOptions}
                        notFoundContent={
                          loadingProviders ? (
                            <div style={{ textAlign: "center", padding: 8 }}>
                              <Spin size="small" />
                            </div>
                          ) : (
                            "No companies found"
                          )
                        }
                        labelRender={({ value }) => renderProviderLabel(value)}
                        optionRender={(option) => (
                          <div className="signup-provider-option">
                            <img src={option.data.logo} alt="" />
                            <span>{option.label}</span>
                          </div>
                        )}
                      />
                    </Form.Item>
                    {!loadingProviders && fuelProviders.length === 0 ? (
                      <div className="signup-provider-empty">
                        No fuel providers available. Please try again later.
                      </div>
                    ) : null}

                    <Form.Item
                      name="Mobile"
                      label="Mobile No"
                      tooltip="Pakistan: 03XXXXXXXXX or +92 3XXXXXXXXX"
                      rules={[
                        {
                          required: true,
                          message: "Please enter Mobile No",
                        },
                        {
                          validator: (_, value) => {
                            if (!value || !String(value).trim()) {
                              return Promise.resolve();
                            }
                            const m = normalizeMobile(value);
                            if (!/^92\d{10}$/.test(m)) {
                              return Promise.reject(
                                new Error(
                                  "Enter a valid Pakistan mobile (12 digits starting with 92)."
                                )
                              );
                            }
                            return Promise.resolve();
                          },
                        },
                      ]}
                    >
                      <Input
                        prefix={<PhoneOutlined />}
                        placeholder="03001234567"
                      />
                    </Form.Item>

                    <Form.Item
                      name="Email"
                      label="Email Address"
                      rules={[
                        {
                          required: true,
                          message: "Please enter your Email Address!",
                        },
                        {
                          validator: (_, value) => {
                            if (!value || !String(value).trim()) {
                              return Promise.resolve();
                            }
                            if (!isValidEmail(value)) {
                              return Promise.reject(
                                new Error("Please enter a valid email address.")
                              );
                            }
                            return Promise.resolve();
                          },
                        },
                      ]}
                    >
                      <Space.Compact style={{ width: "100%" }}>
                        <Input
                          prefix={<MailOutlined />}
                          type="email"
                          placeholder="Email Address"
                          onChange={handleEmailChange}
                        />
                        <Button
                          type="primary"
                          shape="round"
                          onClick={() => handleButtonClick()}
                          disabled={isButtonDisabled}
                          loading={Optloading}
                        >
                          Get Code
                        </Button>
                      </Space.Compact>
                    </Form.Item>
                    <Form.Item
                      name="OTPCode"
                      label="Verification Code"
                      rules={[
                        {
                          required: true,
                          message: "Please enter verification code!",
                        },
                      ]}
                    >
                      <Input
                        prefix={<MailOutlined />}
                        name="OTPCode"
                        type="verification"
                        placeholder="Verification Code"
                      />
                    </Form.Item>

                    <Form.Item
                      name="Password"
                      label="Password"
                      rules={[
                        {
                          required: true,
                          message: "Please input your Password!",
                        },
                        {
                          min: 8,
                          message:
                            "Password must be at least 8 characters (same as server requirement).",
                        },
                      ]}
                    >
                      <Input.Password
                        prefix={<LockOutlined />}
                        type="password"
                        placeholder="Password"
                      />
                    </Form.Item>

                    <Form.Item className="signup-submit-item">
                      <Button
                        type="primary"
                        shape="round"
                        htmlType="submit"
                        loading={loading}
                        block
                      >
                        Sign Up
                      </Button>
                    </Form.Item>
                  </Form>

                  <div className="signup-login-link">
                    Already have an account?{" "}
                    <Link to="/login">Login Now</Link>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SignUp;
